export default function formatTime(time) {
    return time < 10 ? '0' + time : time;
}